import { Component,EventEmitter,OnInit, Output } from '@angular/core';
import { ProductService } from '@app/services/Product/product.service';
import { Paging } from '@app/model/paging'; 
import { ActivatedRoute, Router } from '@angular/router'; 
import { BusinessDetailsService } from '@app/services/BusinessDetails/businessDetails.service';
import { BusinessPaginData } from '@app/model/business-pagin-data';
import { LoaderService } from '@app/services/loader/loader.service';
import { ProductPaginData } from '@app/model/product-pagin-data';
import { Category } from '@app/model/category';

@Component({
  selector: 'app-search-list',
  templateUrl: './search-list.component.html',
  styleUrls: ['./search-list.component.css'],
})
export class SearchListComponent implements OnInit {
  searchList: any;
  filteredSearch: any[] = [];

  productList: any;
  filteredProducts: any[] = [];

  currentIndex = -1;

  totalCount: number = 0;
  pagination: number = 1;
  itemsPerPage:number =8;

  searchType:any;
  searchName: any;
  searchLocation: any;
  searchCategory: any;
  searchText:any;
  
  constructor(
    private route: ActivatedRoute,
    private loader: LoaderService,
    private businessService: BusinessDetailsService,
    private productService: ProductService) { 
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.searchType = params['type'];
      this.searchName = params['name'];
      this.searchLocation = params['location'];
      this.searchCategory = params['category'];
      this.searchText = params['findAny'];
 
      if(this.searchName && this.searchCategory){
        if(this.searchType == 'b') {
          this.searchByBusiness(this.searchName, this.searchLocation, this.searchCategory);
        } else {
          this.searchByProduct(this.searchName, this.searchLocation, this.searchCategory);
        }
      } else if(this.searchText){
        this.searchByAny(this.searchText);
      }
      else {
        if(this.searchType == 'b') {
          this.getBusinessList();
        } else {
          this.getProducts();
        }
      }
    });
  }

  @Output() editedEvent = new EventEmitter<Boolean>();
	toggleClass: boolean = true;
  filterEvent(){
    this.toggleClass = !this.toggleClass;    
    this.editedEvent.emit(this.toggleClass);   //this call into parent search.component.ts
  }

  //For toggle hide show
	showHideClass: boolean = true;
  clickListEvent(){
      this.showHideClass = !this.showHideClass;       
  }

  getBusinessList() : void {
    let filterObj: Paging = new Paging();
    let businessPagingObj: BusinessPaginData = new BusinessPaginData();
    this.businessService.getAllBusinessInfo(filterObj).subscribe({
      next: (data) => {
        businessPagingObj.BusinessInfo = data as BusinessPaginData ;
        this.searchList = businessPagingObj.BusinessInfo;
        this.filteredSearch = this.searchList?.data
        this.totalCount = this.searchList?.data.length;
      }
    }
  );
  }

  searchByAny(any:any) : void {
    let filterObj: Paging = new Paging();
    let businessPagingObj: BusinessPaginData = new BusinessPaginData();
    this.businessService.searchBusinessByAny(any, filterObj).subscribe({
      next: (res) => {
        businessPagingObj.BusinessInfo = res as BusinessPaginData ;
        this.searchList = businessPagingObj.BusinessInfo;
        if(this.searchList?.data.length > 0){
          this.filteredSearch = this.searchList?.data;
          this.totalCount = this.searchList?.data.length;
        } else {
          this.filteredSearch = this.searchList?.data;
          this.totalCount = 0;
        }
      }
    }
    );
  }

  applyFilter(filterCriteria:any): void {
    if(this.searchType == 'b') {
      this.applyFilterByBusiness(filterCriteria);
    } else {
      this.applyFilterByProduct(filterCriteria);
    }
  }

  //Search by business 
  async searchByBusiness(searchName:any, location:any, category:any): Promise<void> {
    this.filterCriteria = {
      name: searchName,
      category: category,
      subCategory: null,
      country: null,
      state: null,
      district: location
    }; 
    
    if(searchName || category){
      await this.businessListByFilter(this.filterCriteria);
    } else {
      this.getBusinessList();
      this.totalCount = this.filteredSearch.length;
    }
  }

  //Filter business by name / category / country
  async applyFilterByBusiness(filterCriteria:any): Promise<void> {
    filterCriteria = {
      name: filterCriteria.name,
      category: filterCriteria.category,
      subCategory: filterCriteria.subCategory,
      country: filterCriteria.country,
      state: filterCriteria.state,
      district: filterCriteria.district
    }; 

    if(filterCriteria.name || filterCriteria.category || filterCriteria.country){
      await this.businessListByFilter(filterCriteria);
    } else {
      this.getBusinessList();
      this.totalCount = this.filteredSearch.length;
    }
  }

  // Common method for search and filter
  businessListByFilter(filterCriteria:any){
    let filterObj: Paging = new Paging();
      let businessPagingObj: BusinessPaginData = new BusinessPaginData();
      this.businessService.filterBusiness(filterObj, filterCriteria).subscribe({
        next: (data) => {
          businessPagingObj.BusinessInfo = data as BusinessPaginData ;
          this.searchList = businessPagingObj.BusinessInfo;
          this.filteredSearch = this.searchList?.data
          if(this.searchList?.data.length > 0){
            this.filteredSearch = this.searchList?.data;
            this.totalCount = this.searchList?.data.length;
          } else {
            this.filteredSearch = this.searchList?.data;
            this.totalCount = 0;
          }
          } 
      }
  )}

  //Sort business
  sortByBusiness(e:any){
    var order= e.target.value;
    switch (e.target.value) {
      case "asc": {
        this.filteredSearch.sort((a:any, b:any) => {
          return order === 'asc'
              ? a.businessName.localeCompare(b.businessName)
              : b.businessName.localeCompare(a.businessName);
        });
        break;
      }
      case "desc": {
        this.filteredSearch.sort((a:any, b:any) => {
          return order === 'desc'
              ? b.businessName.localeCompare(a.businessName)
              : a.businessName.localeCompare(b.businessName);
          });
          break;
      }
      case "category": {
        this.filteredSearch.sort((a:any, b:any) => {
          return order === 'category'
              ? a.categoryInfoId - b.categoryInfoId 
              : b.categoryInfoId - a.categoryInfoId;
          });
          break;
      }
      case "country": {
      this.filteredSearch.sort((a:any, b:any) => {
        return order === 'country'
            ? b.countryInfoId - a.countryInfoId 
            : a.countryInfoId - b.countryInfoId;
        });
      }
    }
  }
  
  // Get all products
  getProducts() : void {
    let filterObj: Paging = new Paging();
    let productPagingObj: ProductPaginData = new ProductPaginData();
    this.productService.getAllSellerProducts(filterObj).subscribe({
      next: (res) => {
        productPagingObj.Products = res as ProductPaginData ;
        this.productList = productPagingObj.Products;
        this.filteredProducts = this.productList?.data;
        this.totalCount = this.productList?.data.length;
        //console.log('API Response:', this.productList?.data); // Log the response
      }
    }
    );
  }

  filterCriteria:any;
  //Search by product  
  async searchByProduct(searchName:any, location:any, category:any): Promise<void>  {
    this.filterCriteria = {
      name: searchName,
      category: category,
      subCategory: null,
      country: null,
      state: null,
      district: location
    }; 
    
    if(searchName || category){
      await this.productListByFilter(this.filterCriteria);
      // this.businessService.searchBusinessByNameId(name, category, filterObj).subscribe()
    } else {
      this.getProducts();
      //this.filteredBusiness = this.businessList?.data;
      this.totalCount = this.filteredProducts.length;
    }
  }

  //Filter product by name / category / country
  async applyFilterByProduct(filterCriteria:any): Promise<void> {
    filterCriteria = {
      name: filterCriteria.name,
      category: filterCriteria.category,
      subCategory: filterCriteria.subCategory,
      country: filterCriteria.country,
      state: filterCriteria.state,
      district: filterCriteria.district
    }; 

    if(filterCriteria.name || filterCriteria.category || filterCriteria.country){
      await this.productListByFilter(filterCriteria);
    } else {
      this.getProducts();
      //this.filteredProducts = this.productList?.data;
      this.totalCount = this.filteredProducts.length;
    }
  }

  // Common method for product search and filter
  productListByFilter(filterCriteria:any){
    let filterObj: Paging = new Paging();
    let productPagingObj: ProductPaginData = new ProductPaginData();
    this.productService.filterProduct(filterObj, filterCriteria).subscribe({
      next: (res) => {
        productPagingObj.Products = res as ProductPaginData ;
        this.productList = productPagingObj.Products;
        if(this.productList?.data.length > 0){
          this.filteredProducts = this.productList?.data;
          this.totalCount = this.productList?.data.length;
        } else {
          this.filteredProducts = this.productList?.data;
          this.totalCount = 0;
        }
      }
    });
  }
  
  // Sort Product
  sortByProduct(e:any){
    var order= e.target.value;
    switch (e.target.value) {
      case "asc": {
        this.filteredProducts.sort((a:any, b:any) => {
          return order === 'asc'
              ? a.sellProductTitle.localeCompare(b.sellProductTitle)
              : b.sellProductTitle.localeCompare(a.sellProductTitle);
        });
        break;
      }
      case "desc": {
        this.filteredProducts.sort((a:any, b:any) => {
          return order === 'desc'
              ? b.sellProductTitle.localeCompare(a.sellProductTitle)
              : a.sellProductTitle.localeCompare(b.sellProductTitle);
          });
          break;
      }
      case "low": {
        this.filteredProducts.sort((a:any, b:any) => {
          return order === 'low'
              ? a.sellProductPrice - b.sellProductPrice 
              : b.sellProductPrice - a.sellProductPrice;
          });
          break;
      }
      case "high": {
      this.filteredProducts.sort((a:any, b:any) => {
        return order === 'high'
            ? b.sellProductPrice - a.sellProductPrice 
            : a.sellProductPrice - b.sellProductPrice;
        });
      }
    }
  }

  // Pagination 
  renderPage(event: number) {
    this.pagination = event;
    this.getBusinessList();
    window.scroll(0,0);
  }
  
  //Search Filter business
  // applyFilterByBusiness(filterCriteria:any): void {
  //   filterCriteria = {
  //     name: filterCriteria.name,
  //     category: filterCriteria.category,
  //     subCategory: filterCriteria.subCategory,
  //     country: filterCriteria.country,
  //     state: filterCriteria.state,
  //     district: filterCriteria.district
  //   };
    
  //   if(filterCriteria.name || filterCriteria.category || filterCriteria.country){
  //     this.filteredSearch = this.searchList?.data.filter((business:any) =>
  //       business.businessName.toLowerCase().includes(filterCriteria.name.toLowerCase()) ||
  //       business.categoryInfoId === filterCriteria.category &&
  //       business.subCategoryInfoId === filterCriteria.subCategory || 
  //       business.countryInfoId === filterCriteria.country || 
  //       business.stateInfoId === filterCriteria.state || 
  //       business.districtInfoId.toLowerCase().includes(filterCriteria.district.toLowerCase())
  //     );
  //     this.totalCount = this.filteredSearch.length;
  // } else {
  //     //this.filteredSearch = this.searchList?.data;
  //     this.getBusinessList(); 
  //     this.totalCount = this.filteredSearch.length;
  // }
  // }
  
}
